import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import PropTypes from 'prop-types';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { createInputsReducer } from '../reducers';
import connectWithInputs from '../util/connectWithInputs';
/**
 * Creates a local store for redux-inputs unique to this component and its children
 * The caveat here is that if the component unmounts, the store is destroyed, just like component state
 */

var LocalInputs = /*#__PURE__*/function (_React$Component) {
  _inherits(LocalInputs, _React$Component);

  var _super = _createSuper(LocalInputs);

  function LocalInputs(props) {
    var _this;

    _classCallCheck(this, LocalInputs);

    _this = _super.call(this, props);
    var inputsConfig = props.inputsConfig;
    _this._store = createStore(combineReducers({
      inputs: createInputsReducer(inputsConfig)
    }), applyMiddleware(thunk));
    _this._ConnectedInputs = connectWithInputs(inputsConfig)()(function (_ref) {
      var reduxInputs = _ref.reduxInputs,
          children = _ref.children;
      return children(reduxInputs);
    });
    return _this;
  }

  _createClass(LocalInputs, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var ConnectedInputs = this._ConnectedInputs; // Connects children component in propsMode so we don't have to set up a `Provider`

      return /*#__PURE__*/React.createElement(ConnectedInputs, {
        store: this._store,
        children: children
      });
    }
  }]);

  return LocalInputs;
}(React.Component);

export { LocalInputs as default };
LocalInputs.propTypes = {
  inputsConfig: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired // Callback with reduxInputs props

};